<template>
  <section class="mt-2">
    <PagaresList />
  </section>
</template>

<script>
import PagaresList from './PagaresList.vue'

export default {
  components: {
    PagaresList,
  },

}
</script>
